export default {
    'blockquote': 'Цитата',
    'bold': 'Жирный',
    'code': 'Код',
    'color': 'Цвет текста',
    'coloredText': 'Цветной текст',
    'hr': 'Горизонтальная линия',
    'image': 'Изображение',
    'externalImage': 'Изображение по ссылке',
    'uploadImage': 'Загрузить изображение',
    'uploadFailed': 'Загрузка прервана',
    'uploadError': 'Ошибка загрузки',
    'imageUrl': 'Url',
    'imageSize': 'Размер',
    'imageAlt': 'Alt',
    'restoreImageSize': 'Восстановить оригинальный размер',
    'uploading': 'Загрузка...',
    'indent': 'Отступ',
    'outdent': 'Выступ',
    'italic': 'Курсив',
    'link': 'Вставить ссылку',
    'linkText': 'Текст',
    'linkUrl': 'Url',
    'linkTarget': 'Target',
    'openLinkInCurrentWindow': 'Открыть в текущей вкладке',
    'openLinkInNewWindow': 'Открыть в новой вкладке',
    'removeLink': 'Удалить ссылку',
    'ol': 'Упорядоченный список',
    'ul': 'Неупорядоченный список',
    'strikethrough': 'Зачеркивание',
    'table': 'Таблица',
    'deleteRow': 'Удалить строку',
    'insertRowAbove': 'Вставить строку выше',
    'insertRowBelow': 'Вставить строку ниже',
    'deleteColumn': 'Удалить столбец',
    'insertColumnLeft': 'Вставить столбец слева',
    'insertColumnRight': 'Вставить столбец справа',
    'deleteTable': 'Удалить таблицу',
    'title': 'Заголовок',
    'normalText': 'Текст',
    'underline': 'Подчеркивание',
    'alignment': 'Выравнивание',
    'alignCenter': 'По центру',
    'alignLeft': 'По левому краю',
    'alignRight': 'По правому краю',
    'selectLanguage': 'Выбрать язык',
    'fontScale': 'Размер шрифта',
    'fontScaleXLarge': 'XL',
    'fontScaleLarge': 'L',
    'fontScaleNormal': 'Обычный',
    'fontScaleSmall': 'S',
    'fontScaleXSmall': 'XS'
};
